import React from 'react';
import { AppSwitcherSolid } from './icons/app-switcher-solid';
import { ArrowLeft } from './icons/arrow-left';
import { ArrowRight } from './icons/arrow-right';
import { ArrowUp } from './icons/arrow-up';
import { AvatarSolid } from './icons/avatar-solid';
import { ChartBarSolid } from './icons/chart-bar-solid';
import { CheckCircle } from './icons/check-circle';
import { ChevronDownSolid } from './icons/chevron-down-solid';
import { ChevronLeftSolid } from './icons/chevron-left-solid copy';
import { ChevronRightSolid } from './icons/chevron-right-solid';
import { ChevronUpSolid } from './icons/chevron-up-solid';
import { CogSolid } from './icons/cog-solid';
import { DotSolid } from './icons/dot-solid';
import { DotsVertical } from './icons/dots-vertical';
import { Drag } from './icons/drag';
import { Exclamation } from './icons/exclamation';
import { ExclamationCircle } from './icons/exclamation-circle';
import { ExternalLink } from './icons/external-link';
import { Eye } from './icons/eye';
import { HomeSolid } from './icons/home-solid';
import { Info } from './icons/info';
import { LockedClosed } from './icons/locked-closed';
import { PlusSolid } from './icons/plus-solid';
import { Printer } from './icons/printer';
import { QuestionMarkCircle } from './icons/question-mark-circle';
import { SwitchHorizontalSolid } from './icons/switch-horizontal-solid';
import { TemplateSolid } from './icons/template-solid';
import { Trash } from './icons/trash';
import { Truck } from './icons/truck';
import { UploadAlt2 } from './icons/upload-alt-2';
import { UserGroupSolid } from './icons/user-group-solid';
import { XCircle } from './icons/x-circle';
import { XSolid } from './icons/x-solid';
import { Gift } from './icons/gift';
import { Ban } from './icons/ban';
import { Pencil } from './icons/pencil';
import { Bank } from './icons/bank';
import { Refresh } from './icons/refresh';
import { Archive } from './icons/archive';
import { PencilAlt } from './icons/pencil-alt';

export type ISnapIcon = {
  color?: string;
  size?: number;
  title: string;
};

export type IconsMapType = keyof typeof ICONS_MAP;
// add more icons here from './icons-svg.ts' as needed
export const ICONS_MAP = {
  'chevron-down-solid': (props: ISnapIcon) => <ChevronDownSolid {...props} />,
  'chevron-up-solid': (props: ISnapIcon) => <ChevronUpSolid {...props} />,
  'app-switcher-solid': (props: ISnapIcon) => <AppSwitcherSolid {...props} />,
  'avatar-solid': (props: ISnapIcon) => <AvatarSolid {...props} />,
  'switch-horizontal-solid': (props: ISnapIcon) => (
    <SwitchHorizontalSolid {...props} />
  ),
  'user-group-solid': (props: ISnapIcon) => <UserGroupSolid {...props} />,
  'template-solid': (props: ISnapIcon) => <TemplateSolid {...props} />,
  'chart-bar-solid': (props: ISnapIcon) => <ChartBarSolid {...props} />,
  'cog-solid': (props: ISnapIcon) => <CogSolid {...props} />,
  'chevron-left-solid': (props: ISnapIcon) => <ChevronLeftSolid {...props} />,
  'chevron-right-solid': (props: ISnapIcon) => <ChevronRightSolid {...props} />,
  'home-solid': (props: ISnapIcon) => <HomeSolid {...props} />,
  'x-solid': (props: ISnapIcon) => <XSolid {...props} />,
  'plus-solid': (props: ISnapIcon) => <PlusSolid {...props} />,
  'arrow-left': (props: ISnapIcon) => <ArrowLeft {...props} />,
  'arrow-right': (props: ISnapIcon) => <ArrowRight {...props} />,
  'arrow-up': (props: ISnapIcon) => <ArrowUp {...props} />,
  'dot-solid': (props: ISnapIcon) => <DotSolid {...props} />,
  'dots-vertical': (props: ISnapIcon) => <DotsVertical {...props} />,
  'external-link': (props: ISnapIcon) => <ExternalLink {...props} />,
  eye: (props: ISnapIcon) => <Eye {...props} />,
  'check-circle': (props: ISnapIcon) => <CheckCircle {...props} />,
  'exclamation-circle': (props: ISnapIcon) => <ExclamationCircle {...props} />,
  'question-mark-circle': (props: ISnapIcon) => (
    <QuestionMarkCircle {...props} />
  ),
  'upload-alt-2': (props: ISnapIcon) => <UploadAlt2 {...props} />,
  drag: (props: ISnapIcon) => <Drag {...props} />,
  trash: (props: ISnapIcon) => <Trash {...props} />,
  exclamation: (props: ISnapIcon) => <Exclamation {...props} />,
  truck: (props: ISnapIcon) => <Truck {...props} />,
  printer: (props: ISnapIcon) => <Printer {...props} />,
  'x-circle': (props: ISnapIcon) => <XCircle {...props} />,
  info: (props: ISnapIcon) => <Info {...props} />,
  'locked-closed': (props: ISnapIcon) => <LockedClosed {...props} />,
  gift: (props: ISnapIcon) => <Gift {...props} />,
  ban: (props: ISnapIcon) => <Ban {...props} />,
  pencil: (props: ISnapIcon) => <Pencil {...props} />,
  bank: (props: ISnapIcon) => <Bank {...props} />,
  refresh: (props: ISnapIcon) => <Refresh {...props} />,
  archive: (props: ISnapIcon) => <Archive {...props} />,
  'pencil-alt': (props: ISnapIcon) => <PencilAlt {...props} />,
};
